import { render, staticRenderFns } from "./CheckboxSelectionManager.vue?vue&type=template&id=61422176"
import script from "./CheckboxSelectionManager.vue?vue&type=script&lang=ts"
export * from "./CheckboxSelectionManager.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../nuxt-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports